<div class="main-content" *ngIf="vendorForm">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{ color }}-5">
				<h4 class="card-title">
					<i class="material-icons" (click)="back()">arrow_left</i>Create Vendor
				</h4>
			</div>
			<div class="card-body">
				<form [formGroup]="vendorForm" class="text-dark">
					<mat-stepper #stepper>

						<mat-step>
							<ng-template matStepLabel>Billing Information</ng-template>

							<div class="section-group mt-3">
								<p class="section-label">Vendor Identity</p>
								<div class="row">
									<div class="col-md-12">
										<app-address-lookup (setAddress)="getAddress($event)" adressType="establishment"></app-address-lookup>
									</div>
								</div>
								<div class="row mt-2">
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Vendor Name</mat-label>
											<input matInput formControlName="suppname">
										</mat-form-field>
									</div>
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Vendor ID</mat-label>
											<input matInput formControlName="supplierid">
											<mat-hint>Auto-generated — edit to override</mat-hint>
											<mat-error *ngIf="vendorForm.get('supplierid').hasError('isNewvendor')">
												"{{ vendorForm.get('supplierid').value }}" already exists as a Vendor ID
											</mat-error>
										</mat-form-field>
									</div>
								</div>
							</div>

							<mat-divider class="section-divider"></mat-divider>

							<div class="section-group">
								<p class="section-label">Billing Address</p>
								<div class="row">
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Address 1</mat-label>
											<input matInput formControlName="address1">
										</mat-form-field>
									</div>
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Address 2</mat-label>
											<input matInput formControlName="address2">
										</mat-form-field>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>City</mat-label>
											<input matInput formControlName="address3">
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Region</mat-label>
											<mat-select formControlName="address4">
												<mat-option *ngFor="let zone of zones.zones" [value]="zone.code">
													{{ zone.code }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
									<div class="col-md-2">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Postal</mat-label>
											<input matInput formControlName="address5">
										</mat-form-field>
									</div>
									<div class="col-md-2">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Country</mat-label>
											<mat-select formControlName="address6" (selectionChange)="updateZones($event)">
												<mat-option *ngFor="let zone of zones.countries" [value]="zone.name">
													{{ zone.name }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
								</div>
							</div>

							<div class="row justify-content-end mt-2 mb-2">
								<div class="col-auto">
									<button mat-raised-button matStepperNext color="accent" [disabled]="!billingStepValid">Next</button>
								</div>
							</div>
						</mat-step>

						<mat-step *ngIf="banking">
							<ng-template matStepLabel>Banking Information</ng-template>

							<div class="section-group mt-3">
								<p class="section-label">Tax Identification</p>
								<div class="row">
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>BN #</mat-label>
											<input matInput formControlName="bn">
											<mat-hint>Business Number (required if no SIN)</mat-hint>
										</mat-form-field>
									</div>
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>SIN #</mat-label>
											<input matInput formControlName="sin">
											<mat-hint>Social Insurance Number (required if no BN)</mat-hint>
										</mat-form-field>
									</div>
								</div>
							</div>

							<mat-divider class="section-divider"></mat-divider>

							<div class="section-group">
								<p class="section-label">Account Details</p>
								<div class="row">
									<div class="col-md-8">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Beneficiary Name</mat-label>
											<input matInput formControlName="bankbeneficiary">
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Preferred Currency</mat-label>
											<mat-select formControlName="bankcurrencypref">
												<mat-option *ngFor="let currency of currencies" [value]="currency?.currabrev">
													{{ currency.currabrev }} {{ currency.currency }}
												</mat-option>
											</mat-select>
										</mat-form-field>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Bank Name</mat-label>
											<input matInput formControlName="bankname">
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Bank Transit #</mat-label>
											<input matInput formControlName="banktransitno">
										</mat-form-field>
									</div>
									<div class="col-md-4">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Bank Swift Code</mat-label>
											<input matInput formControlName="bankswiftcode">
										</mat-form-field>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Bank Account #</mat-label>
											<input matInput formControlName="bankaccountno">
											<mat-hint>Required if no IBAN</mat-hint>
										</mat-form-field>
									</div>
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>IBAN</mat-label>
											<input matInput formControlName="iban">
											<mat-hint>Required if no Bank Account #</mat-hint>
										</mat-form-field>
									</div>
								</div>
							</div>

							<mat-divider class="section-divider"></mat-divider>

							<div class="section-group">
								<p class="section-label">Bank Address</p>
								<div class="row">
									<div class="col-md-12">
										<app-address-lookup [include_canada]="true" (setAddress)="getAddress($event, 'bank')" adressType="establishment"></app-address-lookup>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Address 1</mat-label>
											<input matInput formControlName="bankaddress1">
										</mat-form-field>
									</div>
									<div class="col-md-6">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Address 2</mat-label>
											<input matInput formControlName="bankaddress2">
										</mat-form-field>
									</div>
								</div>
								<div class="row">
									<div class="col-md-3">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>City</mat-label>
											<input matInput formControlName="bankaddress3">
										</mat-form-field>
									</div>
									<div class="col-md-3">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Region</mat-label>
											<input matInput formControlName="bankaddress4">
										</mat-form-field>
									</div>
									<div class="col-md-3">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Postal</mat-label>
											<input matInput formControlName="bankaddress5">
										</mat-form-field>
									</div>
									<div class="col-md-3">
										<mat-form-field class="full-width" appearance="outline">
											<mat-label>Country</mat-label>
											<input matInput formControlName="bankaddress6">
										</mat-form-field>
									</div>
								</div>
							</div>

							<div class="row justify-content-between mt-2 mb-2">
								<div class="col-auto">
									<button mat-raised-button matStepperPrevious color="accent">Back</button>
								</div>
								<div class="col-auto">
									<button mat-raised-button matStepperNext color="accent">Next</button>
								</div>
							</div>
						</mat-step>

						<mat-step>
							<ng-template matStepLabel>Contact Information</ng-template>

							<div class="row mt-3">
								<div class="col-md-6">
									<div class="card card-profile">
										<div class="card-header card-header-danger card-header-icon">
											<div class="card-icon">
												<i class="material-icons">contact_mail</i>
											</div>
											<p class="card-category"><b>Vendor Contact</b></p>
										</div>
										<div class="card-body">
											<div class="row">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Email</mat-label>
														<input formControlName="email" matInput>
														<mat-error *ngIf="vendorForm.get('email')?.invalid && vendorForm.get('email')?.touched">Email is required</mat-error>
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Phone</mat-label>
														<input formControlName="telephone" matInput mask="(000) 000-0000" [showMaskTyped]="true">
														<mat-error *ngIf="vendorForm.get('telephone')?.invalid && vendorForm.get('telephone')?.touched">Phone is required</mat-error>
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline">
														<mat-label>Website</mat-label>
														<input formControlName="url" matInput>
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline" *ngIf="types">
														<mat-label>Vendor Type</mat-label>
														<mat-select formControlName="supptype">
															<mat-option *ngFor="let type of types.supptypes" [value]="type.typeid">{{ type.typename }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="card card-profile">
										<div class="card-header card-header-warning card-header-icon">
											<div class="card-icon">
												<i class="material-icons">settings</i>
											</div>
											<p class="card-category"><b>Settings</b></p>
										</div>
										<div class="card-body">
											<div class="row">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline" *ngIf="paymentterms">
														<mat-label>Payment Terms</mat-label>
														<mat-select formControlName="paymentterms">
															<mat-option *ngFor="let term of paymentterms" [value]="term?.termsindicator">{{ term.terms }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline" *ngIf="taxes">
														<mat-label>Tax Group</mat-label>
														<mat-select formControlName="taxgroupid">
															<mat-option *ngFor="let tax of taxes" [value]="tax?.taxgroupid">{{ tax.taxgroupdescription }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
											<div class="row">
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline" *ngIf="currencies">
														<mat-label>Currency</mat-label>
														<mat-select formControlName="currcode">
															<mat-option *ngFor="let currency of currencies" [value]="currency?.currabrev">
																{{ currency.currabrev }} {{ currency.currency }}
															</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
												<div class="col-md-6">
													<mat-form-field class="full-width" appearance="outline" *ngIf="bankaccounts">
														<mat-label>Remit Bank Account</mat-label>
														<mat-select formControlName="bankact">
															<mat-option *ngFor="let account of bankaccounts" [value]="account.accountcode">{{ account.bankaccountname }}</mat-option>
														</mat-select>
													</mat-form-field>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="row mt-2">
								<div class="col-md-12">
									<h5 class="mb-2">Documents</h5>
									<ngx-dropzone [multiple]="true" (change)="onSelect($event)" class="dropzone-container">
										<ngx-dropzone-label class="dropzone-label">
											<span class="dropzone-icon material-icons">upload_file</span>
											<span class="dropzone-primary">Drag &amp; drop files here</span>
											<span class="dropzone-secondary">or <u>browse to upload</u> &mdash; W9, bank letters, insurance, etc.</span>
										</ngx-dropzone-label>
										<ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
											<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
										</ngx-dropzone-preview>
									</ngx-dropzone>
								</div>
							</div>

							<div class="row justify-content-between mt-3 mb-2">
								<div class="col-auto">
									<button mat-raised-button matStepperPrevious color="accent">Back</button>
								</div>
								<div class="col-auto">
									<button mat-raised-button color="primary" (click)="updateVendor()">Add Vendor</button>
								</div>
							</div>
						</mat-step>

					</mat-stepper>
				</form>
			</div>
		</div>
	</div>
</div>
